export type NavItem = {
  title: string
  href: string
  description?: string
  prefetch?: boolean
  external?: boolean
  children?: NavItem[]
}

const supportEmail = 'support@luckagents.com'
const escalationsEmail = 'escalations@luckagents.com'
const billingEmail = 'billing@luckagents.com'
const helpCenterUrl = process.env.NEXT_PUBLIC_HELP_CENTER_URL?.trim()
const statusPageUrl = process.env.NEXT_PUBLIC_STATUS_PAGE_URL?.trim()

const helpLinks: NavItem[] = [
  { title: 'Contacto', href: '/contacto' },
  { title: 'Soporte por email', href: `mailto:${supportEmail}`, external: true },
  ...(helpCenterUrl ? [{ title: 'Centro de ayuda', href: helpCenterUrl, external: true }] : []),
  ...(statusPageUrl ? [{ title: 'Estado del servicio', href: statusPageUrl, external: true }] : []),
]

export const siteConfig = {
  name: 'LuckAgents',
  tagline: 'Tu asistente de WhatsApp que nunca duerme',
  description:
    'Automatiza citas, responde clientes y cierra ventas en WhatsApp 24/7. Sin código, configura en 5 minutos.',
  primaryCta: {
    label: 'Empieza gratis',
    href: '/register',
  },
  secondaryCta: {
    label: 'Iniciar sesión',
    href: '/access',
  },
  nav: [
    { title: 'Producto', href: '/#producto' },
    { title: 'Soluciones', href: '/#soluciones' },
    { title: 'Precios', href: '/#precios' },
    { title: 'Clientes', href: '/#testimonios' },
    { title: 'FAQ', href: '/#faq' },
  ] satisfies NavItem[],
  auth: [
    { title: 'Acceso', href: '/access' },
    { title: 'Registro', href: '/register' },
  ],
  footer: {
    company: [
      { title: 'Sobre LuckAgents', href: '/#producto' },
      { title: 'Equipo y cultura', href: '/#recursos' },
      { title: 'Prensa', href: '/#recursos' },
    ] satisfies NavItem[],
    legal: [
      { title: 'Términos y condiciones', href: '/terms' },
      { title: 'Privacidad', href: '/privacy' },
      { title: 'Acuerdo SLA', href: '/sla' },
    ] satisfies NavItem[],
    help: helpLinks,
    socials: [] as NavItem[],
  },
  support: {
    email: supportEmail,
    escalationsEmail,
    billingEmail,
    helpCenterUrl: helpCenterUrl || null,
    statusPageUrl: statusPageUrl || null,
  },
  whatsappNotes: {
    templates: 'Si pasan más de 24 h, reutiliza plantillas aprobadas para reactivar el chat.',
    disclaimer:
      'LuckAgents no está afiliado a WhatsApp ni a Meta. WhatsApp es una marca de Meta Platforms, Inc.',
  },
}
